import styled from "styled-components";

interface IStickyNavigationMenuActiveIndicatorBoxProps {
  position: number;
}

export const StickyNavigationMenuActiveIndicatorDefaultBox = styled.div<IStickyNavigationMenuActiveIndicatorBoxProps>`
  width: 1px;
  height: 5px;
  transform: translateX(${props => props.position}px);
  transition: transform 0.5s ease;

  &::after {
    content: "";
    display: block;
    width: 30px;
    height: 6px;
    background-image: url(${props => props.theme.images.spriteSheet.toString()});
    background-position: -335px -266px;
    transform: translateX(-50%);
  }
`;
